import { render, staticRenderFns } from "./ReporteFacturadoXFechaI.vue?vue&type=template&id=4980badc&scoped=true"
import script from "./ReporteFacturadoXFechaI.vue?vue&type=script&lang=js"
export * from "./ReporteFacturadoXFechaI.vue?vue&type=script&lang=js"
import style0 from "./ReporteFacturadoXFechaI.vue?vue&type=style&index=0&id=4980badc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4980badc",
  null
  
)

export default component.exports